import AgentSignup from '@/components/AgentPanel/AgentSignup';

export default function AgentSignupPage() {
  return <AgentSignup />;
}


export { getServerSideProps } from '@/lib/panelSsr';
